import { getClientInfo } from "./utils/getClientInfo";
import { postControlError } from "./services/ApiGraphql";

// Guarda el userId actual en memoria
let currentUserId: string | undefined = undefined;

/**
 * Permite actualizar el userId dinámicamente sin volver a registrar listeners.
 */
export function setGlobalErrorUser(userId?: string) {
  currentUserId = userId;
  console.log("[GlobalErrorHandlers] userId actualizado:", userId);
}

/**
 * Registra los listeners globales solo una vez.
 * Captura errores de JS, recursos y promesas no manejadas.
 */
export function setupGlobalErrorHandlers() {
  if ((window as any).__globalErrorHandlersRegistered) {
    console.warn("[GlobalErrorHandlers] Ya estaban registrados, omitido.");
    return;
  }
  (window as any).__globalErrorHandlersRegistered = true;

  console.log("[GlobalErrorHandlers] Registrando listeners...");

  // Errores globales
  window.addEventListener("error", async (ev) => {
    try {
      const message =
        (ev && (ev as ErrorEvent).message) || "Unknown error (window.onerror)";
      const filename = (ev as any).filename || "";
      const lineno = (ev as any).lineno || "";
      const colno = (ev as any).colno || "";

      console.error("[global error]", { message, filename, lineno, colno });

      window.dispatchEvent(
        new CustomEvent("app:fatalError", {
          detail: { message: `Error: ${message}`, filename, lineno, colno },
        })
      );

      const clientInfo = getClientInfo();
      const servicio = `GlobalError@${filename}:${lineno}:${colno}`;

      await postControlError(
        currentUserId || "anon",
        clientInfo,
        servicio,
        new Error(message),
        { componentStack: JSON.stringify({ filename, lineno, colno }) } as any
      );
    } catch (err) {
      console.warn("Error al registrar global error:", err);
    }
  });

  // Promesas no manejadas
  window.addEventListener("unhandledrejection", async (ev) => {
    try {
      const reason = (ev as PromiseRejectionEvent).reason;
      const message =
        reason instanceof Error
          ? reason.message
          : String(reason || "Unhandled rejection");

      console.error("[unhandledrejection]", reason);

      const clientInfo = getClientInfo();
      const servicio = "UnhandledPromiseRejection";

      await postControlError(
        currentUserId || "anon",
        clientInfo,
        servicio,
        new Error(message),
        { componentStack: JSON.stringify(reason) } as any
      );
    } catch (err) {
      console.warn("Error al registrar unhandled rejection:", err);
    }
  });
}
